import React from 'react'
import { useNavigate } from 'react-router-dom'

const SignalPeakLanding = () => {
  const navigate = useNavigate()

  const apps = [
    {
      name: 'QwikShift',
      description: 'Streamline your shift management to find and fill open shifts quickly',
      icon: '📅',
      logo: '/qwikshift/logo.png',
      route: '/qwikshift',
      color: '#667eea'
    },
    {
      name: 'Pocket Portfolio',
      description: 'Track your investments with realtime data, detailed charts, stock fundamentals and more',
      icon: '💼',
      logo: '/pocket-portfolio/logo.png',
      route: '/pocket-portfolio',
      color: '#008B8B'
    },
    {
      name: 'Photo Story',
      description: 'Organize your photos and memories the way you want to see them',
      icon: '📸',
      logo: '/photo-story/logo.png',
      route: '/photo-story',
      color: '#C05621'
    },
    {
      name: 'City vs City',
      description: 'Compare cities and discover which one is right for you',
      icon: '🏙️',
      logo: '/city-vs-city/logo.png',
      route: '/city-vs-city',
      color: '#4A90E2'
    }
  ]

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh',
      fontFamily: 'system-ui, sans-serif',
      color: '#2a2a2a',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      {/* Header */}
      <header style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 2rem',
        color: 'white'
      }}>
        <div style={{
          fontSize: '1.5rem',
          fontWeight: 'bold'
        }}>
          Signal Peak Software
        </div>
        <nav style={{
          display: 'flex',
          gap: '1.5rem',
          alignItems: 'center'
        }}>
          <a href="mailto:signalpeaksw@outlook.com" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.9
          }}>
            Contact
          </a>
        </nav>
      </header>

      {/* Hero Section */}
      <section style={{
        textAlign: 'center',
        padding: '4rem 2rem',
        color: 'white'
      }}>
        <h1 style={{
          fontSize: window.innerWidth <= 768 ? '2.5rem' : '4rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
          margin: '0 0 1rem 0'
        }}>
          Welcome to Signal Peak Software
        </h1>
        <p style={{
          fontSize: '1.5rem',
          marginBottom: '2rem',
          opacity: 0.9,
          maxWidth: '800px',
          margin: '0 auto 2rem auto'
        }}>
          Innovative software solutions designed to make your life easier
        </p>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2rem'
        }}>
          <img 
            src="/logo.png" 
            alt="Signal Peak Software Logo" 
            style={{
              height: '120px',
              width: 'auto',
              borderRadius: '16px',
              filter: 'drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4))',
              boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)'
            }}
          />
        </div>
      </section>

      {/* Apps Section */}
      <section style={{
        padding: '4rem 2rem',
        backgroundColor: 'white',
        color: '#2a2a2a'
      }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: '2.5rem',
          marginBottom: '3rem',
          color: '#667eea'
        }}>
          Our Applications
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(4, 1fr)',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {apps.map((app, index) => (
            <div
              key={index}
              onClick={() => navigate(app.route)}
              style={{
                padding: '2.5rem',
                backgroundColor: '#f8f9fa',
                borderRadius: '16px',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'transform 0.3s, box-shadow 0.3s',
                border: `3px solid ${app.color}`,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow = `0 12px 24px ${app.color}40`
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
            >
              <div style={{ 
                fontSize: '4rem', 
                marginBottom: '1.5rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '80px'
              }}>
                {app.logo ? (
                  <img 
                    src={app.logo} 
                    alt={`${app.name} Logo`}
                    style={{
                      height: '80px',
                      width: 'auto',
                      maxWidth: '100%',
                      borderRadius: '16px',
                      filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
                    }}
                  />
                ) : (
                  <span>{app.icon}</span>
                )}
              </div>
              <h3 style={{ 
                fontSize: '2rem', 
                marginBottom: '1rem',
                color: app.color,
                fontWeight: 'bold'
              }}>
                {app.name}
              </h3>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#666',
                flexGrow: 1,
                marginBottom: '1.5rem'
              }}>
                {app.description}
              </p>
              <button
                style={{
                  padding: '0.75rem 2rem',
                  backgroundColor: app.color,
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s',
                  marginTop: 'auto'
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = '0.9'
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = '1'
                }}
              >
                Learn More
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* About Section */}
      <section style={{
        padding: '4rem 2rem',
        backgroundColor: '#f8f9fa',
        color: '#2a2a2a',
        textAlign: 'center'
      }}>
        <h2 style={{
          fontSize: '2.5rem',
          marginBottom: '2rem',
          color: '#667eea'
        }}>
          About Signal Peak Software
        </h2>
        <p style={{
          fontSize: '1.2rem',
          lineHeight: '1.8',
          maxWidth: '800px',
          margin: '0 auto',
          color: '#666'
        }}>
          We create innovative software solutions that solve real-world problems. 
          Our applications are designed with user experience and functionality in mind, 
          helping individuals and businesses work more efficiently.
        </p>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '2rem',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '2rem',
          marginBottom: '1rem',
          flexWrap: 'wrap'
        }}>
          <a href="mailto:signalpeaksw@outlook.com" style={{
            color: 'white',
            textDecoration: 'none',
            opacity: 0.8
          }}>
            Support
          </a>
        </div>
        <p style={{ opacity: 0.7, fontSize: '0.9rem', marginBottom: '0.5rem' }}>
          &copy; {new Date().getFullYear()} Signal Peak Software. All rights reserved.
        </p>
        <p style={{ opacity: 0.7, fontSize: '0.9rem' }}>
          Located in Washington, Utah
        </p>
      </footer>
    </div>
  )
}

export default SignalPeakLanding

